import React from 'react'
import { Redirect } from 'react-router-dom'

class UserQuestionsRedirect extends React.PureComponent {
  render() {
    if (this.props.location && this.props.location.search) {
      const search = this.props.location.search.replace('?user=', '')
      return <Redirect to={{ pathname: `/questions`, state: {user: search} }} />
    } else {
      return ''
    }
  }
}

export default UserQuestionsRedirect



// WEBPACK FOOTER //
// ./src/js/components/UserQuestionsRedirect.js